import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, OnDemandDataIn } from '../../../api/api-reference';
import { formatDateRange, toUtcDate } from '../../../helper/date-utils';
import { DatepickerComponent } from '../../core/components/datepicker/datepicker.component';
import { DateRangeInput } from '../../core/models/date-range-input';

@Component({
  selector: 'app-on-demand-setup',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    AngularSvgIconModule,
    TranslateModule,
    DatepickerComponent,
  ],
  providers: [DatePipe],
  templateUrl: './on-demand-setup.component.html',
  styleUrl: './on-demand-setup.component.scss',
})
export class OnDemandSetupComponent implements OnInit {
  requestData: OnDemandDataIn = new OnDemandDataIn();
  selectedDate: string | null = '';
  isDatepickerShown = false;
  currentRouteSegment: string | undefined;


  constructor(
    private client: Client,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.requestData.meterNo = '';
    const urlPart = this.router.url.split('/').pop() || '';
    this.currentRouteSegment = urlPart.replace('-setup', '') || '';
  }

  onBack() {
    if (this.currentRouteSegment == 'energy') {
      this.router.navigate(['/on-demand/energy']);
    } else if (this.currentRouteSegment == 'power-demand') {
      this.router.navigate(['/on-demand/power-demand']);
    } else if (this.currentRouteSegment == 'load-profile') {
      this.router.navigate(['/on-demand/load-profile']);
    } else if (this.currentRouteSegment == 'event-log') {
      this.router.navigate(['/on-demand/event-log']);
    } else if (this.currentRouteSegment == 'instantaneous-object') {
      this.router.navigate(['/on-demand/instantaneous-object']);
    } else if (this.currentRouteSegment == 'billing-data') {
      this.router.navigate(['/billing-data']);
    } else {
      this.router.navigate(['/on-demand/data-read']);
    }
  }

  onSubmit() {
    if (this.currentRouteSegment == 'energy') {
      this.client.onDemandEnergyRegisters(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/on-demand/energy']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (this.currentRouteSegment == 'power-demand') {
      this.client.onDemandPowerDemand(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/on-demand/power-demand']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (this.currentRouteSegment == 'load-profile') {
      this.client.onDemandLoadProfile(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/on-demand/load-profile']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (this.currentRouteSegment == 'event-log') {
      this.client.onDemandEventLog(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/on-demand/event-log']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (this.currentRouteSegment == 'instantaneous-object') {
      this.client.onDemandInstantaneousObject(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/on-demand/instantaneous-object']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (this.currentRouteSegment == 'billing-data') {
      this.client.onDemandBilling(this.requestData).subscribe({
        next: () => {
          this.router.navigate(['/billing-data']);
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else {
      this.router.navigate(['/on-demand/data-read']);
    }
  }

  onDateRangeChanged(input: DateRangeInput): void {
    const startDate = new Date(input.dateFrom);
    const endDate = new Date(input.dateTo);

    //formating date to DD MMM YYYY format or DD MMM YYYY - DD MMM YYYY if date range
    this.selectedDate = formatDateRange(startDate, endDate);

    this.requestData.readFromDate = toUtcDate(startDate);

    this.requestData.readToDate = toUtcDate(endDate);
  }

  // Getter for converting string to date type
  get inputFromDate(): Date {
    return new Date(this.requestData.readFromDate);
  }

  // Getter for converting string to date type
  get inputToDate(): Date {
    return new Date(this.requestData.readToDate);
  }

  toggleDatepicker() {
    this.isDatepickerShown = !this.isDatepickerShown;
  }
}
